<template>
  <v-card
    :height="height"
    :width="width"
    :flat="flat == undefined || flat == false ? false : true"
    class="d-flex flex-column align-items-center"
  >
    <v-card-subtitle
      style="width: auto; height: 50px"
      class="pa-0 text-center"
      v-if="editName"
    >
      <v-text-field
        outlined
        height="15px"
        append-icon="mdi-close"
        prepend-inner-icon="mdi-check"
        width="150px"
        dense
        :disabled="loading"
        v-model="editNameText"
        :loading="loading"
        @click:prepend-inner="updateTitleName()"
        @click:append="editName = false"
      ></v-text-field>
    </v-card-subtitle>
    <v-card-subtitle v-else class="text-break">
      <v-icon
        @click="
          editName = true;
          editNameText = title;
        "
        size="15"
        >mdi-pencil</v-icon
      >
      {{ title }}
    </v-card-subtitle>
    <v-card-text>
      <div class="audio-controls">
        <v-btn
          outlined
          icon
          class="ma-1"
          :color="color"
          @click="stop"
          :disabled="!loaded"
        >
          <v-icon>{{ stopIcon }}</v-icon>
        </v-btn>
        <v-btn
          outlined
          icon
          class="ma-1"
          :color="color"
          @click="mute"
          :disabled="!loaded"
        >
          <v-icon>{{ isMuted ? volumeMuteIcon : volumeHighIcon }}</v-icon>
        </v-btn>
        <v-btn
          outlined
          icon
          class="ma-1"
          :color="color"
          @click="playing ? pause() : play()"
          :disabled="!loaded"
        >
          <v-icon>{{ playing ? pauseIcon : playIcon }}</v-icon>
        </v-btn>
        <v-btn
          outlined
          icon
          class="ma-1"
          :color="color"
          @click.native="loaded ? download() : reload()"
          v-if="!loaded"
        >
          <v-icon>{{ refreshIcon }}</v-icon>
        </v-btn>
        <v-btn
          v-if="loaded && downloadable"
          outlined
          class="ma-1"
          icon
          :color="color"
          @click="download"
        >
          <v-icon>{{ downloadIcon }}</v-icon>
        </v-btn>
        <!-- <v-btn
          outlined
          icon
          class="ma-1"
          :color="color"
          @click="openFile(file)"
        >
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn> -->
        <!-- <v-btn
          outlined
          icon
          class="ma-1"
          :color="color"
          @click="copyLink(file)"
        >
          <v-icon>mdi-content-copy</v-icon>
        </v-btn> -->
      </div>
      <v-progress-linear
        v-model="percentage"
        height="5"
        style="margin-top: 15px; margin-bottom: 15px"
        @click.native="setPosition()"
        reverse
        :disabled="!loaded"
        class="audio-progress"
      ></v-progress-linear>
      <p>{{ currentTime }} / {{ duration }}</p>
    </v-card-text>
    <v-slider
      v-if="audioSound"
      v-model="playerVolume"
      :prepend-icon="isMuted ? volumeMuteIcon : volumeHighIcon"
      max="1"
      step="0.01"
      min="0"
      class="volume-slider"
    ></v-slider>
    <audio
      id="player"
      ref="player"
      v-on:ended="ended"
      v-on:canplay="canPlay"
      :src="file"
    ></audio>
  </v-card>
</template>
<script>
import { Bus } from "@/main";

const formatTime = (second) =>
  new Date(second * 1000).toISOString().substr(11, 8);

export default {
  name: "audioPlayer",
  props: {
    flat: {
      type: Boolean,
      default: false,
    },
    file: {
      type: String,
      default: null,
    },
    autoPlay: {
      type: Boolean,
      default: false,
    },
    ended: {
      type: Function,
      default: () => {},
    },
    canPlay: {
      type: Function,
      default: () => {},
    },
    color: {
      type: String,
      default: null,
    },
    downloadable: {
      type: Boolean,
      default: true,
    },
    playIcon: {
      type: String,
      default: "mdi-play",
    },
    pauseIcon: {
      type: String,
      default: "mdi-pause",
    },
    stopIcon: {
      type: String,
      default: "mdi-stop",
    },
    refreshIcon: {
      type: String,
      default: "mdi-refresh",
    },
    downloadIcon: {
      type: String,
      default: "mdi-download",
    },
    volumeHighIcon: {
      type: String,
      default: "mdi-volume-high",
    },
    volumeMuteIcon: {
      type: String,
      default: "mdi-volume-mute",
    },
    audioSound: {
      type: Boolean,
      default: true,
    },
    height: {
      type: [Number, String],
      default: "250",
    },
    width: {
      type: [Number, String],
      default: "100%",
    },
    title: String,
    id: [String, Number],
    link: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    duration: function () {
      return this.audio ? formatTime(this.totalDuration) : "";
    },
  },
  data() {
    return {
      firstPlay: true,
      isMuted: false,
      loaded: false,
      playing: false,
      paused: false,
      percentage: 0,
      currentTime: "00:00:00",
      audio: undefined,
      totalDuration: 0,
      playerVolume: 0.5,
      editName: false,
      editNameText: "",
      loading: false,
    };
  },
  watch: {
    playerVolume(val) {
      if (this.audio) {
        this.audio.volume = val;
      }
    },
  },
  methods: {
    openFile(url) {
      if (url) window.open(url, "_blank");
    },
    copyLink(url) {
      if (!url) return;
      navigator.clipboard
        .writeText(url)
        .then(() => {
          this.$toast.success("لینک صدا با موفقیت کپی شد.");
        })
        .catch(() => {
          this.$toast.error("خطا در کپی لینک");
        });
    },
    download() {
      const a = document.createElement("a");
      a.href = this.file;
      a.download = "audio";
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    setPosition() {
      this.audio.currentTime = parseInt(
        (this.audio.duration / 100) * this.percentage,
      );
    },
    stop() {
      this.audio.pause();
      this.paused = true;
      this.playing = false;
      this.audio.currentTime = 0;
    },
    play() {
      if (this.playing) return;
      this.audio.play().then((_) => (this.playing = true));
      this.paused = false;
    },
    pause() {
      this.paused = !this.paused;
      this.paused ? this.audio.pause() : this.audio.play();
    },
    // download() {
    //   this.audio.pause();
    //   window.open(this.file, "download");
    // },
    mute() {
      // this.isMuted = !this.isMuted;
      // this.audio.muted = this.isMuted;
      this.audio.muted = !this.audio.muted;
      this.isMuted = this.audio.muted;
    },
    reload() {
      this.audio.pause();
      this.audio.currentTime = 0;
      this.playing = false;
      this.paused = false;
      this.loaded = false;
      this.percentage = 0;
      this.currentTime = "00:00:00";
      this.audio.load();
    },
    _handleLoaded: function () {
      if (this.audio.readyState >= 2) {
        if (this.audio.duration === Infinity) {
          // Fix duration for streamed audio source or blob based
          // https://stackoverflow.com/questions/38443084/how-can-i-add-predefined-length-to-audio-recorded-from-mediarecorder-in-chrome/39971175#39971175
          this.audio.currentTime = 1e101;
          this.audio.ontimeupdate = () => {
            this.audio.ontimeupdate = () => {};
            this.audio.currentTime = 0;
            this.totalDuration = parseInt(this.audio.duration);
            this.loaded = true;
          };
        } else {
          this.totalDuration = parseInt(this.audio.duration);
          this.loaded = true;
        }

        if (this.autoPlay) this.audio.play();
      } else {
        throw new Error("Failed to load sound file");
      }
    },
    _handlePlayingUI: function (e) {
      // this.audio.volume = this.playerVolume;
      this.percentage = (this.audio.currentTime / this.audio.duration) * 100;
      this.currentTime = formatTime(this.audio.currentTime);
      this.playing = true;
    },
    _handlePlayPause: function (e) {
      if (e.type === "play" && this.firstPlay) {
        // in some situations, audio.currentTime is the end one on chrome
        this.audio.currentTime = 0;
        if (this.firstPlay) {
          this.firstPlay = false;
        }
      }
      if (
        e.type === "pause" &&
        this.paused === false &&
        this.playing === false
      ) {
        this.currentTime = "00:00:00";
      }
    },
    _handleEnded() {
      this.paused = this.playing = false;
    },
    init: function () {
      this.audio.addEventListener("timeupdate", this._handlePlayingUI);
      this.audio.addEventListener("loadeddata", this._handleLoaded);
      this.audio.addEventListener("pause", this._handlePlayPause);
      this.audio.addEventListener("play", this._handlePlayPause);
      this.audio.addEventListener("ended", this._handleEnded);
    },

    updateTitleName() {
      if (this.link) {
        this.loading = true;
        const local_url = this.$robotApi;
        this.$api
          .put(`${local_url}/files/update/${this.id}`, {
            title: this.editNameText,
          })
          .then((data) => {
            this.$toast.success(this.$t("successfully_completed"));

            // this.editNameText = "";

            this.editName = false;
            this.$emit("title-updated", this.editNameText);
            Bus.$emit("updateList", true);
          })
          .catch((err) => {
            this.$toast.error(this.$t("problem_occurred"));
          })
          .finally(() => (this.loading = false));
      } else {
        try {
          this.$emit("click", { id: this.id, title: this.editNameText });
          this.$toast.success(this.$t("successfully_completed"));
          this.editName = false;
        } catch {
          this.$toast.error(this.$t("problem_occurred"));
        } finally {
          this.loading = false;
        }
      }
    },
  },
  mounted() {
    this.audio = this.$refs.player;
    this.init();
  },
  beforeDestroy() {
    this.audio.removeEventListener("timeupdate", this._handlePlayingUI);
    this.audio.removeEventListener("loadeddata", this._handleLoaded);
    this.audio.removeEventListener("pause", this._handlePlayPause);
    this.audio.removeEventListener("play", this._handlePlayPause);
    this.audio.removeEventListener("ended", this._handleEnded);
  },
};
</script>

<style scoped>
.ltr-progress .v-progress-linear__bar {
  left: 0 !important;
  right: auto !important;
}
.audio-progress {
  direction: ltr;
}
.volume-slider {
  width: 100%;
  max-width: 220px;
  margin: 0 auto;
}
.audio-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1px !important;
  flex-wrap: nowrap;
}
.v-btn--icon.v-size--default {
  height: 30px !important;
  width: 30px !important;
}
.cover {
  height: 30px;
  background: #d3d1d14d !important;
  border-radius: 5px !important;
}
</style>
